<template>
  <div>
    <div>
      <el-carousel
        arrow="always"
        id="banner"
        height="45vw"
        class="home-banner"
        :interval="4000"
      >
        <el-carousel-item v-for="(item, index) in bannerlist" :key="index">
          <div class="titlBox">
            <div class="innerbox">
              <p class="tt">
                {{
                  isChinese
                    ? item.key
                    : item.keyEn
                }}
              </p>
              <p class="tt">
                {{
                  isChinese
                    ? item.key2
                    : item.key2En
                }}
              </p>
              <!-- <p class="tt" >
              {{
                isChinese ? "匠心防腐" : "Professional Metal Surface Treatment"
              }}
            </p>
            <p class="tt" style="margin-top: 15px">
              {{
                isChinese
                  ? "匠心防腐"
                  : "Anti-corrosion with Ingenuity and Work with Craftsmanship"
              }}
            </p> -->
            
              <div style="display: flex" class="btnbox">
              <p @click="gotoRouter('/AboutUs')">
                {{ isChinese ? "关于计氏" : "About Jishi" }}
              </p>
              <p @click="gotoRouter('/Solution')">
                {{ isChinese ? "解决方案" : "Solution" }}
              </p>
            </div>
            </div>
          </div>
          <img :src="item.value" class="banner-img" />
        </el-carousel-item>

        <!-- <div class="titlBox">
          <div class="innerbox">
            <div style="display: flex" class="btnbox">
              <p @click="gotoRouter('/AboutUs')">
                {{ isChinese ? "关于计氏" : "About Jishi" }}
              </p>
              <p @click="gotoRouter('/Solution')">
                {{ isChinese ? "解决方案" : "Solution" }}
              </p>
            </div>
          </div>
        </div> -->
      </el-carousel>
    </div>

    <!-- 解决方案 -->
    <div class="solutionBox">
      <p class="baseBigTit">{{ isChinese ? "解决方案" : "Solution" }}</p>
      <p class="basesmallTit">
        {{
          isChinese
            ? "致力于为客户提供多样的解决方案和优质的服务"
            : "Committed to providing customers with a variety of solutions and quality services"
        }}
      </p>

      <div class="picbox">
        <div
          v-for="(item, index) in soluteList"
          class="inner"
          @click="goToSolu"
          :key="index"
        >
          <img :src="item.value" alt />
          <!-- hover 产生的效果-->
          <div class="block">
            <div class="hhh">
              <p style="font-size: 24px">
                {{ isChinese ? item.key : item.keyEn }}
              </p>
              <p style="font-size: 18px">
                {{ isChinese ? "了解更多" : "Learn more" }}
                <i class="icon el-icon-caret-right" style="color: #edac1a"></i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用领域 -->
    <div class="yyly">
      <p class="baseBigTit">{{ isChinese ? "应用领域" : "Applications" }}</p>
      <p class="basesmallTit">
        {{
          isChinese
            ? "应用产品广泛，为您提供全方位专业化服务"
            : "Widely applied to provide you with a full range of professional services"
        }}
      </p>
      <yyly-temp></yyly-temp>
    </div>

    <div class="section4">
      <img
        :src="
          section4Img
            ? section4Img
            : require('../../static/images/home/GYWM-12.jpg')
        "
        alt
      />
    </div>

    <!-- 新闻中心 -->
    <div class="yyly newsBox">
      <p class="baseBigTit">{{ isChinese ? "新闻中心" : "News Center" }}</p>
      <p class="basesmallTit">
        {{
          isChinese
            ? "了解计氏，从每一件小事记起"
            : "Learn about Jishi from every little thing"
        }}
      </p>
      <div class="section4b">
        <div
          v-for="(item, index) in newslist"
          class="aaa"
          @click="gotoDetail(item.id, item)"
          :key="index"
        >
          <img :src="item.cover" alt />
          <!-- hover 产生的效果-->
          <div class="block">
            <div>
              <p style="font-size: 15px">
                <i class="icon el-icon-caret-right" style="color: #edac1a"></i>
                {{ isChinese ? item.title : item.titleEn }}
              </p>
              <p
                class="innerSec4b_p"
                style="font-size: 1.3rem; margin-left: 2.5rem"
              >
                {{ isChinese ? item.simple : item.simpleEn }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yylyTemp from "./baseTemp/yylyTemp";

export default {
  name: "home2",
  data() {
    return {
      isChinese: undefined,
      bannerlist: [],
      clientWight: "",
      cardheight: 0,
      soluteList: [],
      section4Img: "",
      newslist: [],
    };
  },
  computed: {
    setCAE() {
      return this.$store.state.cAeSatus;
    },
  },
  watch: {
    //监听路由变化
    setCAE(newVal) {
      this.isChinese = newVal === 1 ? true : false;
    },
  },
  created() {
    this.getInfo();
    this.getJieJueFangAn();
    this.getMidImg();
    this.getNewsList();
    this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
  },
  mounted() {
    // this.Init();
  },
  components: { yylyTemp },
  methods: {
    Init() {
      // 动态设置背景图的高度为浏览器可视区域高度
      // 首先在Virtual DOM渲染数据时，设置下背景图的高度．
      // 然后监听window的resize事件．在浏览器窗口变化时再设置下背景图高度．
      // setTimeout(() => {
      //   this.clientWight = $("#banner").css("width");
      //   this.clientWight = this.clientWight.replace("px", "");
      //   document
      //     .getElementById("banner")
      //     .setAttribute("style", "height: " + this.clientWight * 0.5 + "px");
      //   window.addEventListener(
      //     "resize",
      //     () =>
      //       (this.clientWight = document.querySelector("#banner").offsetWidth),
      //     document
      //       .getElementById("banner")
      //       .setAttribute("style", "height: " + this.clientWight * 0.48 + "px")
      //   );
      // }, 0);
    },
    getInfo() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "首页Banner",
            key: "",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data;
              this.bannerlist = resdata.data.pictureJSONArray;
            }
          }.bind(this)
        );
    },
    getJieJueFangAn() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "首页-解决方案",
            key: "",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data;
              this.soluteList = resdata.data.pictureJSONArray;
            }
          }.bind(this)
        );
    },
    goToSolu() {
      this.$router.push({ path: "/Solution" });
    },
    gotoRouter(url) {
      this.$router.push({ path: url });
    },
    getMidImg() {
      this.$http
        .get("/jishi/api/publicity/info", {
          params: {
            title: "首页中部图",
            key: "",
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              this.section4Img = res.data.data.logo;
              // let resdata = res.data.list;
              // if (resdata && resdata.length > 0) {
              //   this.section4Img = resdata[0].value;
              // }
            }
          }.bind(this)
        );
    },
    getNewsList() {
      this.$http
        .get("/jishi/api/activity/list", {
          params: {
            page: 1,
            limit: 2,
          },
        })
        .then(
          function (res) {
            if (res && res.data.code === 0) {
              let resdata = res.data.page;
              this.newslist = resdata.list;
            }
          }.bind(this)
        );
    },
    gotoDetail(id, item) {
      let routeData = this.$router.resolve({
        path: "/News/NewsDetail/id=" + id,
        query: { title: this.isChinese ? item.title : item.titleEn },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="stylus">
img {
  width: 100%;
  height: 100%;
}

.home-banner {
  height: 50vw;
  position: relative;

  .banner-img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  .titlBox {
    position: absolute;
    color: white;
    z-index: 995;
    top: 0;
    width: 100%;
    height: 93%;
    display: flex;
    align-items: center;
    justify-content: center;

    .innerbox {
      min-width: 300px;
      padding-top:20rem;

      .tt {
        /* font-family Bold */
        font-size: 80px;
        text-align: center;
        padding: 0;
        margin: 0;
      }

      .btnbox {
        display: flex;
        justify-content: space-around;
        margin-top: 60px;

        p {
          border: 1px solid white;
          font-size: 24px;
          padding: 8px 50px;
          cursor: pointer;
        }

        p:nth-child(2) {
          margin-left: 3vw;
        }
      }
    }
  }
}

.solutionBox {
  margin-top: 110px;

  .picbox {
    display: flex;
    position: relative;
    cursor: pointer;

    .block {
      display: none;
    }
  }

  .picbox>div:nth-child(2) {
    margin-left: 10px;
  }

  .inner {
    position: relative;
  }

  .inner:hover .block {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
  }

  .inner:hover .block>div {
    position: absolute;
    bottom: 3vw;
    left: 4vw;
    color: white;
  }
}

.baseBigTit {
  text-align: center;
  color: #595757;
  font-family: Medium;
  font-size: 40px;
}

.basesmallTit {
  text-align: center;
  font-size: 18px;
  // color: #9ca0aa;
  color: black;
  padding-bottom: 50px;
  font-family: 'Light';
}

.yyly {
  background: #F4F4F5;
  margin-top: 80px;
  padding-top: 140px;
}

.section4 {
  width: 100%;
  margin-top: 80px;
}

.newsBox {
  padding-bottom: 100px;
}

.section4b {
  display: flex;
  width: 65%;
  margin: 0 auto;
  position: relative;

  .aaa {
    position: relative;
    margin-left: 10px;
    flex: 1;

    .block {
      display: none;
    }
  }

  .aaa:hover .block {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    color: white;

    div {
      position: absolute;
      bottom: 1vw;
      /* left 2vw */
      padding: 0 2vw;
    }
  }

  .innerSec4b_p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
</style>
<style scoped>
.home-banner >>> .el-carousel__indicators--outside {
  position: absolute;
  bottom: -2px;
  left: 50%;
}
.home-banner >>> .el-carousel__arrow--left {
  display: none;
}
.home-banner >>> .el-carousel__arrow--right {
  display: none;
}
.home-banner >>> .el-carousel__button {
  border: 1px solid black;
}
.home-banner >>> .is-active .el-carousel__button {
  background: #edac1a;
  border: 1px solid #edac1a;
}
.hhh {
  width: 83.5%;
  border-top: 1px solid #cccccc;
}
@media (max-width: 768px) {
  .tt {
    margin-top: 10px !important;
    font-size: 20px !important;
  }
  .innerbox{
    padding-top: 40px !important;

  }
  .btnbox {
        margin-top: 30px !important;
  }
  .solutionBox {
  margin-top: 30px !important;
  }
  .picbox{
    display: block !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
   .picbox>div:nth-child(2) {
    margin-left: 0 !important;
  }
  .btnbox > p {
    font-size: 12px !important;
    padding: 8px 20px !important;
  }
  .baseBigTit {
  font-size: 18px !important;
}
.basesmallTit {
  font-size: 14px !important;
  padding-bottom: 0 !important;
}
.yyly {
  margin-top: 0 !important;
  padding-top: 10px !important;
}
.newsBox {
  padding-bottom: 10px !important;
}
.section4 {
  display: none !important;
}
.section4b {
  width: 100% !important;
  display: block !important;
  
}
.section4b > .aaa {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home2.vue